import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  :root {
    --azul-razio: #1a83ff;
    --red-razio: #c53030;
		--warning-razio: #ff9000;
    --gray-border-lw: #CFD8DC;
    --gray-border-md: #B0BEC5;
    --gray-border-lg: #90A4AE;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    // outline: 0;
  }

  html {
    @media (max-width: 1080px) {
      font-size: 93.75%;
    }
    @media (max-width: 720px) {
      font-size: 87.5%;
    }
  }

  body {
    background: #fff;
    color: #333;
    -webkit-font-smoothing: antialiased;
    scroll-behavior: smooth;

    button:focus{
      outline: thin dotted;
      outline: 0px auto -webkit-focus-ring-color;
      outline-offset: 0px;
    }
  }

  body, input, button, select, textarea {
    font-family: 'Roboto', 'Open Sans', 'Roboto Slab', serif;
    font-size: 16px;
    font-weight: 400;
  }

  h1, h2, h3,h4 ,h5 ,h6, strong {
    font-weight: 600;
  }

  button {
    cursor: pointer;
    &:hover {
        filter: brightness(0.9);
      }
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
